import { useState } from 'react';
import { SearchRounded, AspectRatioRounded } from '@mui/icons-material';
import {
  Box,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  FilledInput,
  InputAdornment
} from '@mui/material';
import styles from './styles';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { useDispatch, useSelector } from 'react-redux';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';

const TargetAnswersControls = () => {
  const classes = styles();
  const dispatch = useDispatch();

  const { preferences } = useSelector((state) => state.currentUser);

  const [searchTerm, setSearchTerm] = useState(null);

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    dispatch({
      type: REDUX_ACTIONS.TARGET_ANSWERS_SEARCH_CONTROL,
      payload: { searchValue: searchTerm },
    });
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleAspectRatio = useAspectRatio();

  return (
    <Grid alignItems="flex-end" justifyContent="flex-end" sx={{ marginLeft: 'auto' }}>
      <Box className={classes.container}>
        <Box>
          <FormControl>
            <InputLabel
              htmlFor="outlined-adornment-search"
              inputprops={{ classes: { root: classes.searchBar } }}
            >
              Search
            </InputLabel>
            <FilledInput
              className={classes.searchBar}
              id="outlined-adornment-search"
              type="text"
              label="Search"
              value={searchTerm || ''}
              onChange={handleSearchTerm}
              onKeyDown={handleEnter}
              endAdornment={
                  <InputAdornment position="end">
                      <IconButton
                          edge="end"
                          onClick={() => handleSearch()}
                      >
                          <SearchRounded />
                      </IconButton>
                  </InputAdornment>
              }
            />
          </FormControl>
        </Box>
        <Box className={classes.aspectRatioContainer}>
          <IconButton
            edge="end"
            onClick={() => {
              handleAspectRatio(!preferences.aspectChanged);
            }}
          >
            <AspectRatioRounded />
          </IconButton>
        </Box>
      </Box>
    </Grid>
  );
};

export default TargetAnswersControls;
